import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Product } from '../../types/content';
import { useBrand } from '../../contexts/BrandContext';
import { getCategory } from '../../data/categories';
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    productImage
  } = useBrand();
  const category = getCategory(product.category);
  const isFda = product.status === 'FDA-approved';
  return <li className="flex" data-id="element-273" data-mp="1y3xjq9idnndn">
      <Link to={`/shop/${product.slug}`} className="group flex w-full flex-col overflow-hidden rounded-brand border border-ink/10 bg-cream-light transition-colors duration-150 ease-republic hover:border-ink/40" data-id="element-274" data-mp="1t303w3kub5fb">
        <div className="relative overflow-hidden bg-cream-deep" data-id="element-275" data-mp="224hex7je4gx5">
          <img src={productImage(product.slug, product.image)} alt={`${product.name}, ${product.form}`} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-republic group-hover:scale-[1.02]" data-id="element-276" data-mp="co88dhsedi1s" />
          {isFda && <span className="absolute left-4 top-4 rounded-full bg-ink px-3 py-1 text-[0.625rem] uppercase tracking-label text-cream" data-id="element-277" data-mp="3lq9yz6acp7wg">
              FDA-approved
            </span>}
          {!isFda && product.popular && <span className="absolute left-4 top-4 rounded-full bg-cream-light px-3 py-1 text-[0.625rem] uppercase tracking-label text-brick" data-id="element-278" data-mp="3vi7gsvvv6y45">
              Popular
            </span>}
        </div>

        <div className="flex flex-1 flex-col p-5" data-id="element-279" data-mp="8e9nftp5w5c8">
          <p className="text-[0.625rem] uppercase tracking-label text-ink-muted" data-id="element-280" data-mp="db016adhuouh">
            {category?.name}
          </p>
          <h3 className="mt-2 font-serif text-xl font-semibold leading-tight text-ink" data-id="element-281" data-mp="i9umbiyxophr">
            {product.name}
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-282" data-mp="2f4zfl4lwxmbe">{product.tagline}</p>
          <p className="mt-3 text-xs text-ink-muted" data-id="element-283" data-mp="2k3tw1zweqysc">
            {product.form} · {product.strength}
          </p>

          <div className="mt-auto flex items-end justify-between gap-4 pt-5" data-id="element-284" data-mp="271yj5sifijmx">
            <div data-id="element-285" data-mp="2741jb5dapt5d">
              <p className="text-lg font-semibold text-ink" data-id="element-286" data-mp="2lz7o5p0nnlx4">
                ${product.price}
                <span className="ml-1 text-xs font-normal text-ink-muted" data-id="element-287" data-mp="2lwv14xg1ild7">{product.cadence}</span>
              </p>
              <p className="mt-1 text-xs text-ink-muted" data-id="element-288" data-mp="2uzmej2sh7r7h">{product.priceNote}</p>
            </div>
            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-ink/15 text-ink transition-colors duration-150 ease-republic group-hover:border-ink group-hover:bg-ink group-hover:text-cream" data-id="element-289" data-mp="2q12nwp2xtr8s">
              <ArrowRightIcon className="h-4 w-4" strokeWidth={1.75} data-id="element-290" data-mp="2zrxbbwrx6wvt" />
            </span>
          </div>
        </div>
      </Link>
    </li>;
}